var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTakeawayDelivery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Food-Delivery-Bag--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Food Delivery Bag Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7.64a1.55 1.55 0 0 0 -1.55 -1.46h-2v-1A5.2 5.2 0 0 0 7 5.2c0 4.09 0 3.91 0.14 4.17a0.75 0.75 0 0 1 -1.36 -0.43V6.18h-1.2A1.56 1.56 0 0 0 3 7.64c-1 13.92 -0.93 13.15 -0.93 13.88A2.48 2.48 0 0 0 4.58 24h14.84a2.48 2.48 0 0 0 2.48 -2.48c0 -0.71 0.04 0.11 -0.9 -13.88Zm-6.28 -1.46H8.53v-1a3.71 3.71 0 0 1 7.41 0c0 4.1 0 3.91 0.14 4.17a0.75 0.75 0 0 1 -1.36 -0.43Zm-1.05 5.21a0.5 0.5 0 0 1 0.66 -0.23 6.58 6.58 0 0 1 3 5.95 0.5 0.5 0 0 1 -0.5 0.5h-2.21v2.78a0.5 0.5 0 0 1 -0.5 0.5 0.51 0.51 0 0 1 -0.5 -0.5c0 -9.3 -0.02 -8.85 0.05 -9Zm-6.57 0.11a0.5 0.5 0 0 1 1 0v3.13c0 0.3 0.35 0.63 0.9 0.76V11.5a0.5 0.5 0 0 1 0.5 -0.5 0.5 0.5 0 0 1 0.5 0.5v3.89c0.55 -0.13 0.91 -0.46 0.91 -0.76V11.5a0.5 0.5 0 0 1 0.5 -0.5 0.5 0.5 0 0 1 0.5 0.5v3.13A2 2 0 0 1 10 16.41v4a0.5 0.5 0 0 1 -0.5 0.5 0.51 0.51 0 0 1 -0.5 -0.5v-4a2 2 0 0 1 -1.9 -1.78Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTakeawayDelivery);
export default ForwardRef;